import request from '@/utils/request.js';
import Qs from 'qs';

/**
 * 信用评价固定数据查询接口
 */
export class RegularQueryController {
    constructor() {
        this.baseurl = 'regularQueryController.assx/';
    }

    /**
     * 基础信息详情-项目负责人绑定情况-PC
     * token:String, wyqydm:String, startIndex:int, maxSize:int, pjDate:String, bodyType:int
     */
    getManagerPersonRoleByEaAreaCode_v1(token, wyqydm, startIndex, maxSize, pjDate, bodyType){
        return request.post(this.baseurl + 'getManagerPersonRoleByEaAreaCode_v1', Qs.stringify({ token:token, wyqydm:wyqydm, startIndex:startIndex, maxSize:maxSize, pjDate:pjDate, bodyType:bodyType }));
    }

    /**
     * 企业基础信息
     * orgCode:String, orgName:String, creditBodyType:String, isScoreAsc:int, startIndex:int, maxSize:int, pjDate:String
     */
    getCreditEvaBasicInfoCompanyVOList_builtBureauWebsite_v1(orgCode, orgName, creditBodyType, isScoreAsc, startIndex, maxSize, pjDate){
        return request.post(this.baseurl + 'getCreditEvaBasicInfoCompanyVOList_builtBureauWebsite_v1', Qs.stringify({ orgCode:orgCode, orgName:orgName, creditBodyType:creditBodyType, isScoreAsc:isScoreAsc, startIndex:startIndex, maxSize:maxSize, pjDate:pjDate }));
    }

    /**
     * 项目负责人基础信息
     * eaAreaCode:String, eaAreaName:String, creditBodyType:String, isScoreAsc:int, totalScore_l:String, totalScore_r:String, managerName:String, companyName:String, startIndex:int, maxSize:int, managerNameOrCompanyName:String, pjDate:String
     */
    getCreditEvaBasicInfoManagerVOList_builtBureauWebsite_v1(eaAreaCode, eaAreaName, creditBodyType, isScoreAsc, totalScore_l, totalScore_r, managerName, companyName, startIndex, maxSize, managerNameOrCompanyName, pjDate){
        return request.post(this.baseurl + 'getCreditEvaBasicInfoManagerVOList_builtBureauWebsite_v1', Qs.stringify({ eaAreaCode:eaAreaCode, eaAreaName:eaAreaName, creditBodyType:creditBodyType, isScoreAsc:isScoreAsc, totalScore_l:totalScore_l, totalScore_r:totalScore_r, managerName:managerName, companyName:companyName, startIndex:startIndex, maxSize:maxSize, managerNameOrCompanyName:managerNameOrCompanyName, pjDate:pjDate }));
    }

    /**
     * 企业评价情况详情2/项目负责人评价情况2-PC
     * openId:String, token:String, companyCode:String, mob:String, managerName:String, creditBodyType:int, pjDate:String
     */
    getCreditEvaBasicInfoVOByRole_public_v1(openId, token, companyCode, mob, managerName, creditBodyType, pjDate){
        return request.post(this.baseurl + 'getCreditEvaBasicInfoVOByRole_public_v1', Qs.stringify({ openId:openId, token:token, companyCode:companyCode, mob:mob, managerName:managerName, creditBodyType:creditBodyType, pjDate:pjDate }));
    }

    /**
     * 基础信息详情-共有资金开户情况
     * wyqydm:String, startIndex:int, maxSize:int, pjDate:String, bodyType:int
     */
    getCreditEvaBasicCommonAccountList_builtBureauWebsite_v1(wyqydm, startIndex, maxSize, pjDate, bodyType){
        return request.post(this.baseurl + 'getCreditEvaBasicCommonAccountList_builtBureauWebsite_v1', Qs.stringify({ wyqydm:wyqydm, startIndex:startIndex, maxSize:maxSize, pjDate:pjDate, bodyType:bodyType }));
    }

    /**
     * 项目负责人基础信息-PC
     * token:String, eaAreaCode:String, eaAreaName:String, creditBodyType:String, isScoreAsc:int, totalScore_l:String, totalScore_r:String, managerName:String, companyName:String, startIndex:int, maxSize:int, pjDate:String
     */
    getCreditEvaBasicInfoManagerVOList_v1(token, eaAreaCode, eaAreaName, creditBodyType, isScoreAsc, totalScore_l, totalScore_r, managerName, companyName, startIndex, maxSize, pjDate){
        return request.post(this.baseurl + 'getCreditEvaBasicInfoManagerVOList_v1', Qs.stringify({ token:token, eaAreaCode:eaAreaCode, eaAreaName:eaAreaName, creditBodyType:creditBodyType, isScoreAsc:isScoreAsc, totalScore_l:totalScore_l, totalScore_r:totalScore_r, managerName:managerName, companyName:companyName, startIndex:startIndex, maxSize:maxSize, pjDate:pjDate }));
    }

    /**
     * 基础信息详情-共有资金开户情况-PC
     * token:String, wyqydm:String, startIndex:int, maxSize:int, pjDate:String, bodyType:int
     */
    getCreditEvaBasicCommonAccountList_v1(token, wyqydm, startIndex, maxSize, pjDate, bodyType){
        return request.post(this.baseurl + 'getCreditEvaBasicCommonAccountList_v1', Qs.stringify({ token:token, wyqydm:wyqydm, startIndex:startIndex, maxSize:maxSize, pjDate:pjDate, bodyType:bodyType }));
    }

    /**
     * 基础信息详情-街道社区评价
     * areaCode:String, pjDate:String, bodyType:int
     */
    getCommunityEvaluateListByAreaCode_v1(areaCode, pjDate, bodyType){
        return request.post(this.baseurl + 'getCommunityEvaluateListByAreaCode_v1', Qs.stringify({ areaCode:areaCode, pjDate:pjDate, bodyType:bodyType }));
    }

    /**
     * 获取企业基础信息详情/获取项目负责人基础信息详情
     * keyId:String, dateTime:Date, orgCode:String, personName:String, personTel:String, bodyType:int, pjDate:String
     */
    getCreditEvaBasicInfo_builtBureauWebsite_v1(keyId, dateTime, orgCode, personName, personTel, bodyType, pjDate){
        return request.post(this.baseurl + 'getCreditEvaBasicInfo_builtBureauWebsite_v1', Qs.stringify({ keyId:keyId, dateTime:dateTime, orgCode:orgCode, personName:personName, personTel:personTel, bodyType:bodyType, pjDate:pjDate }));
    }

    /**
     * 基础信息详情穿透页面头部信息-PC
     * token:String, wyqydm:String, pjDate:String, bodyType:int
     */
    getManagerAndCompanyInfo_v1(token, wyqydm, pjDate, bodyType){
        return request.post(this.baseurl + 'getManagerAndCompanyInfo_v1', Qs.stringify({ token:token, wyqydm:wyqydm, pjDate:pjDate, bodyType:bodyType }));
    }

    /**
     * 企业评价情况详情1/项目负责人评价情况1
     * mob:String, orgCode:String, type:String, pjDate:String
     */
    getCreditEvaInformationVO_builtBureauWebsite_v1(mob, orgCode, type, pjDate){
        return request.post(this.baseurl + 'getCreditEvaInformationVO_builtBureauWebsite_v1', Qs.stringify({ mob:mob, orgCode:orgCode, type:type, pjDate:pjDate }));
    }

    /**
     * 基础信息详情-通知发布响应率
     * wyqydm:String, pjDate:String, bodyType:int
     */
    getCreditEvaBasicNotice_builtBureauWebsite_v1(wyqydm, pjDate, bodyType){
        return request.post(this.baseurl + 'getCreditEvaBasicNotice_builtBureauWebsite_v1', Qs.stringify({ wyqydm:wyqydm, pjDate:pjDate, bodyType:bodyType }));
    }

    /**
     * 基础信息详情-项目负责人绑定情况
     * wyqydm:String, startIndex:int, maxSize:int, pjDate:String, bodyType:int
     */
    getManagerPersonRoleByEaAreaCode_builtBureauWebsite_v1(wyqydm, startIndex, maxSize, pjDate, bodyType){
        return request.post(this.baseurl + 'getManagerPersonRoleByEaAreaCode_builtBureauWebsite_v1', Qs.stringify({ wyqydm:wyqydm, startIndex:startIndex, maxSize:maxSize, pjDate:pjDate, bodyType:bodyType }));
    }

    /**
     * 基础信息详情-通知发布响应率-PC
     * token:String, wyqydm:String, pjDate:String, bodyType:int
     */
    getCreditEvaBasicNotice_v1(token, wyqydm, pjDate, bodyType){
        return request.post(this.baseurl + 'getCreditEvaBasicNotice_v1', Qs.stringify({ token:token, wyqydm:wyqydm, pjDate:pjDate, bodyType:bodyType }));
    }

    /**
     * 基础信息详情-物业合同备案情况
     * wyqydm:String, startIndex:int, maxSize:int, pjDate:String, bodyType:int
     */
    getCreditEvaBasicContractList_builtBureauWebsite_v1(wyqydm, startIndex, maxSize, pjDate, bodyType){
        return request.post(this.baseurl + 'getCreditEvaBasicContractList_builtBureauWebsite_v1', Qs.stringify({ wyqydm:wyqydm, startIndex:startIndex, maxSize:maxSize, pjDate:pjDate, bodyType:bodyType }));
    }

    /**
     * 物业服务企业各指标计分情况 / 项目负责人各指标计分情况
     * thisDate:Date, orgName:String, mangerName:String, eaAreaName:String, orgCode:String, mangerTel:String, startIndex:int, maxSize:int, totalCount:boolean, type:int, option:int, bodyType:int, pjDate:String
     */
    getCreditEvaBasicInfoList_builtBureauWebsite_v1(thisDate, orgName, mangerName, eaAreaName, orgCode, mangerTel, startIndex, maxSize, totalCount, type, option, bodyType, pjDate){
        return request.post(this.baseurl + 'getCreditEvaBasicInfoList_builtBureauWebsite_v1', Qs.stringify({ thisDate:thisDate, orgName:orgName, mangerName:mangerName, eaAreaName:eaAreaName, orgCode:orgCode, mangerTel:mangerTel, startIndex:startIndex, maxSize:maxSize, totalCount:totalCount, type:type, option:option, bodyType:bodyType, pjDate:pjDate }));
    }

    /**
     * 企业评价导出
     * pjDate:String
     */
    exportCompany(pjDate){
        return request.post(this.baseurl + 'exportCompany', Qs.stringify({ pjDate:pjDate }));
    }

    /**
     * 企业基础信息-PC
     * token:String, orgCode:String, orgName:String, creditBodyType:String, isScoreAsc:int, startIndex:int, maxSize:int, pjDate:String
     */
    getCreditEvaBasicInfoCompanyVOList_v1(token, orgCode, orgName, creditBodyType, isScoreAsc, startIndex, maxSize, pjDate){
        return request.post(this.baseurl + 'getCreditEvaBasicInfoCompanyVOList_v1', Qs.stringify({ token:token, orgCode:orgCode, orgName:orgName, creditBodyType:creditBodyType, isScoreAsc:isScoreAsc, startIndex:startIndex, maxSize:maxSize, pjDate:pjDate }));
    }

    /**
     * 企业评价情况/项目负责人评价情况
     * companyName:String, companyCode:String, eaAreaName:String, managerName:String, orderByItem:int, creditBodyType:int, startIndex:int, maxSize:int, managerNameOrCompanyName:String, pjDate:String
     */
    getCreditEvaSummaryVOList_builtBureauWebsite_v1(companyName, companyCode, eaAreaName, managerName, orderByItem, creditBodyType, startIndex, maxSize, managerNameOrCompanyName, pjDate){
        return request.post(this.baseurl + 'getCreditEvaSummaryVOList_builtBureauWebsite_v1', Qs.stringify({ companyName:companyName, companyCode:companyCode, eaAreaName:eaAreaName, managerName:managerName, orderByItem:orderByItem, creditBodyType:creditBodyType, startIndex:startIndex, maxSize:maxSize, managerNameOrCompanyName:managerNameOrCompanyName, pjDate:pjDate }));
    }

    /**
     * 企业评价情况详情3/项目负责人评价情况3-PC
     * token:String, keyId:String, dateTime:Date, bodyType:int, type:int, orgCode:String, pjDate:String
     */
    getCreditEvaRanking_v1(token, keyId, dateTime, bodyType, type, orgCode, pjDate){
        return request.post(this.baseurl + 'getCreditEvaRanking_v1', Qs.stringify({ token:token, keyId:keyId, dateTime:dateTime, bodyType:bodyType, type:type, orgCode:orgCode, pjDate:pjDate }));
    }

    /**
     * 基础信息详情-专业能力测评
     * wyqydm:String, startIndex:int, maxSize:int, pjDate:String, bodyType:int
     */
    getCreditEvaBasicTrainList_builtBureauWebsite_v1(wyqydm, startIndex, maxSize, pjDate, bodyType){
        return request.post(this.baseurl + 'getCreditEvaBasicTrainList_builtBureauWebsite_v1', Qs.stringify({ wyqydm:wyqydm, startIndex:startIndex, maxSize:maxSize, pjDate:pjDate, bodyType:bodyType }));
    }

    /**
     * 企业评价情况/项目负责人评价情况-PC
     * openId:String, token:String, companyName:String, companyCode:String, eaAreaName:String, managerName:String, orderByItem:int, creditBodyType:int, startIndex:int, maxSize:int, managerNameOrCompanyName:String, pjDate:String
     */
    getCreditEvaSummaryVOList_v1(openId, token, companyName, companyCode, eaAreaName, managerName, orderByItem, creditBodyType, startIndex, maxSize, managerNameOrCompanyName, pjDate){
        return request.post(this.baseurl + 'getCreditEvaSummaryVOList_v1', Qs.stringify({ openId:openId, token:token, companyName:companyName, companyCode:companyCode, eaAreaName:eaAreaName, managerName:managerName, orderByItem:orderByItem, creditBodyType:creditBodyType, startIndex:startIndex, maxSize:maxSize, managerNameOrCompanyName:managerNameOrCompanyName, pjDate:pjDate }));
    }

    /**
     * 基础信息详情-物业合同备案情况-PC
     * token:String, wyqydm:String, startIndex:int, maxSize:int, pjDate:String, bodyType:int
     */
    getCreditEvaBasicContractList_v1(token, wyqydm, startIndex, maxSize, pjDate, bodyType){
        return request.post(this.baseurl + 'getCreditEvaBasicContractList_v1', Qs.stringify({ token:token, wyqydm:wyqydm, startIndex:startIndex, maxSize:maxSize, pjDate:pjDate, bodyType:bodyType }));
    }

    /**
     * 基础信息详情穿透页面头部信息
     * wyqydm:String, pjDate:String, bodyType:int
     */
    getManagerAndCompanyInfo_builtBureauWebsite_v1(wyqydm, pjDate, bodyType){
        return request.post(this.baseurl + 'getManagerAndCompanyInfo_builtBureauWebsite_v1', Qs.stringify({ wyqydm:wyqydm, pjDate:pjDate, bodyType:bodyType }));
    }

    /**
     * 企业评价情况详情1/项目负责人评价情况1-PC
     * openId:String, token:String, mob:String, orgCode:String, type:String, pjDate:String
     */
    getCreditEvaInformationVO_v1(openId, token, mob, orgCode, type, pjDate){
        return request.post(this.baseurl + 'getCreditEvaInformationVO_v1', Qs.stringify({ openId:openId, token:token, mob:mob, orgCode:orgCode, type:type, pjDate:pjDate }));
    }

    /**
     * 物业服务企业各指标计分情况 / 项目负责人各指标计分情况-PC
     * token:String, thisDate:Date, orgName:String, mangerName:String, eaAreaName:String, orgCode:String, mangerTel:String, startIndex:int, maxSize:int, totalCount:boolean, type:int, option:int, bodyType:int, pjDate:String
     */
    getCreditEvaBasicInfoList_public_v1(token, thisDate, orgName, mangerName, eaAreaName, orgCode, mangerTel, startIndex, maxSize, totalCount, type, option, bodyType, pjDate){
        return request.post(this.baseurl + 'getCreditEvaBasicInfoList_public_v1', Qs.stringify({ token:token, thisDate:thisDate, orgName:orgName, mangerName:mangerName, eaAreaName:eaAreaName, orgCode:orgCode, mangerTel:mangerTel, startIndex:startIndex, maxSize:maxSize, totalCount:totalCount, type:type, option:option, bodyType:bodyType, pjDate:pjDate }));
    }

    /**
     * 基础信息详情-安全检查率-PC
     * token:String, wyqydm:String, startIndex:int, maxSize:int, pjDate:String, bodyType:int
     */
    getCreditEvaBasicSafeCheckList_v1(token, wyqydm, startIndex, maxSize, pjDate, bodyType){
        return request.post(this.baseurl + 'getCreditEvaBasicSafeCheckList_v1', Qs.stringify({ token:token, wyqydm:wyqydm, startIndex:startIndex, maxSize:maxSize, pjDate:pjDate, bodyType:bodyType }));
    }

    /**
     * 基础信息详情-信息公开率
     * wyqydm:String, pjDate:String, bodyType:int
     */
    getCreditEvaBasicPublic_builtBureauWebsite_v1(wyqydm, pjDate, bodyType){
        return request.post(this.baseurl + 'getCreditEvaBasicPublic_builtBureauWebsite_v1', Qs.stringify({ wyqydm:wyqydm, pjDate:pjDate, bodyType:bodyType }));
    }

    /**
     * 基础信息详情-专业能力测评-PC
     * token:String, wyqydm:String, startIndex:int, maxSize:int, pjDate:String, bodyType:int
     */
    getCreditEvaBasicTrainList_v1(token, wyqydm, startIndex, maxSize, pjDate, bodyType){
        return request.post(this.baseurl + 'getCreditEvaBasicTrainList_v1', Qs.stringify({ token:token, wyqydm:wyqydm, startIndex:startIndex, maxSize:maxSize, pjDate:pjDate, bodyType:bodyType }));
    }

    /**
     * 基础信息详情-满意度得分&评分反馈情况
     * wyqydm:String, pjDate:String, bodyType:int
     */
    getCreditEvaBasicEvaluationFeedbackInfo_v1(wyqydm, pjDate, bodyType){
        return request.post(this.baseurl + 'getCreditEvaBasicEvaluationFeedbackInfo_v1', Qs.stringify({ wyqydm:wyqydm, pjDate:pjDate, bodyType:bodyType }));
    }

    /**
     * 基础信息详情-信息公开率-PC
     * token:String, wyqydm:String, pjDate:String, bodyType:int
     */
    getCreditEvaBasicPublic_v1(token, wyqydm, pjDate, bodyType){
        return request.post(this.baseurl + 'getCreditEvaBasicPublic_v1', Qs.stringify({ token:token, wyqydm:wyqydm, pjDate:pjDate, bodyType:bodyType }));
    }

    /**
     * 企业评价情况详情3/项目负责人评价情况3
     * keyId:String, dateTime:Date, bodyType:int, type:int, orgCode:String, pjDate:String
     */
    getCreditEvaRanking_builtBureauWebsite_v1(keyId, dateTime, bodyType, type, orgCode, pjDate){
        return request.post(this.baseurl + 'getCreditEvaRanking_builtBureauWebsite_v1', Qs.stringify({ keyId:keyId, dateTime:dateTime, bodyType:bodyType, type:type, orgCode:orgCode, pjDate:pjDate }));
    }

    /**
     * 获取企业基础信息详情/获取项目负责人基础信息详情-PC
     * token:String, keyId:String, dateTime:Date, orgCode:String, personName:String, personTel:String, bodyType:int, pjDate:String
     */
    getCreditEvaBasicInfo_v1(token, keyId, dateTime, orgCode, personName, personTel, bodyType, pjDate){
        return request.post(this.baseurl + 'getCreditEvaBasicInfo_v1', Qs.stringify({ token:token, keyId:keyId, dateTime:dateTime, orgCode:orgCode, personName:personName, personTel:personTel, bodyType:bodyType, pjDate:pjDate }));
    }

    /**
     * 项目负责人评价导出
     * pjDate:String
     */
    exportManager(pjDate){
        return request.post(this.baseurl + 'exportManager', Qs.stringify({ pjDate:pjDate }));
    }

    /**
     * 基础信息详情-共有资金开户情况-是否应开
     * area:String, pjDate:String, bodyType:int
     */
    getAreaCommonAccountOpen_v1(area, pjDate, bodyType){
        return request.post(this.baseurl + 'getAreaCommonAccountOpen_v1', Qs.stringify({ area:area, pjDate:pjDate, bodyType:bodyType }));
    }

    /**
     * 企业评价情况详情2/项目负责人评价情况2
     * companyCode:String, mob:String, managerName:String, creditBodyType:int, pjDate:String
     */
    getCreditEvaBasicInfoVOByRole_builtBureauWebsite_v1(companyCode, mob, managerName, creditBodyType, pjDate){
        return request.post(this.baseurl + 'getCreditEvaBasicInfoVOByRole_builtBureauWebsite_v1', Qs.stringify({ companyCode:companyCode, mob:mob, managerName:managerName, creditBodyType:creditBodyType, pjDate:pjDate }));
    }

    /**
     * 基础信息详情-安全检查率
     * wyqydm:String, startIndex:int, maxSize:int, pjDate:String, bodyType:int
     */
    getCreditEvaBasicSafeCheckList_builtBureauWebsite_v1(wyqydm, startIndex, maxSize, pjDate, bodyType){
        return request.post(this.baseurl + 'getCreditEvaBasicSafeCheckList_builtBureauWebsite_v1', Qs.stringify({ wyqydm:wyqydm, startIndex:startIndex, maxSize:maxSize, pjDate:pjDate, bodyType:bodyType }));
    }
}